import React from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';

import { OCardBrowse as OCardBrowseComp } from '@marriott/mi-web-ui-kit';
import clsx from 'clsx';

export const OCardBrowseConfig = {
  emptyLabel: 'OCardBrowse',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/o-card-browse`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OCardBrowse = (props: any) => {
  const model = props.model || {};
  const { styleclass, componentId } = model;

  return (
    <div
      data-testid="o-card-browse-comp"
      data-component-name="o-card-browse"
      id={componentId}
      className={clsx(styleclass)}
    >
      <EditableComponent config={OCardBrowseConfig} {...props}>
        <OCardBrowseComp {...props} />
      </EditableComponent>
    </div>
  );
};
